/*eslint-disable */
define(function (require) {
    var $ = require('jquery');

    /**
     * Function to check if the document is being accessed on a mobile device
     */
    var isSmallScreen = function () {
        return window.innerWidth <= 640;
    };

    /**
     * Function to check if the keyboard on mobile/table device is open
     * @return {Boolean}     true if open / false if closed
     */
    var isKeyboardOpen = function () {
        var doc = document.documentElement;

        var scrollLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        var scrollHeight = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
        var naturalHeight = window.innerHeight;

        window.scrollTo(scrollLeft, document.body.scrollHeight);

        var keyboardHeight = naturalHeight - window.innerHeight;
        window.scrollTo(scrollLeft, scrollHeight);

        return keyboardHeight > 0;
    };

    return {
        isSmallScreen: isSmallScreen,
        isKeyboardOpen: isKeyboardOpen
    };
});
